import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import Button from "@mui/material/Button";
import { useCsAttribute, useSubstructureApi, useSubstructureMeta, } from "@plansoft-configuration-renderer/framework";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
import { useIcon } from "../../Icons";
/**
 * Adds a new subconfiguration instance to the current configuration attribute.
 * @returns
 */
export function SubstructureAddButton() {
    const attribute = useCsAttribute();
    const { addSubCfgObject } = useSubstructureApi();
    const { canAdd } = useSubstructureMeta();
    const SubstructureAddIcon = useIcon("SubstructureAddIcon");
    const t = useUiTranslator();
    return (_jsx(Fragment, { children: canAdd && (_jsx(Button, { type: "button", onClick: () => addSubCfgObject({ path: attribute.path }), startIcon: _jsx(SubstructureAddIcon, {}), children: t("ConfigurationRenderer:SubconfigurationInstance.add", "Add") })) }));
}
SubstructureAddButton.displayName = "SubstructureAddButton";
//# sourceMappingURL=SubstructureAddButton.js.map